<script setup>
import { ref, inject, computed, watchEffect } from 'vue';
import { useRequest } from 'src/utils/hooks/use-requset';
import { useServiceType } from 'src/utils/hooks/store/use-service-type';
import { useIns, useStore } from 'src/utils/v2_helper/common';
import { useRouter } from 'src/utils/v2_helper/router';
import { getTable } from 'src/utils/common';
import { getVouchers } from 'src/api/home';
import { useStoreCloseDialog } from 'src/utils/hooks/useStoreCloseDialog';
import Nearest from '../nearest/Index.vue';
import VoucherItem from './VoucherItem.vue';
import { useServiceMap } from './config';

const { push } = useStoreCloseDialog();
const router = useRouter();
const app = useIns();
const store = useStore();
const { support, opened } = useServiceType();
const SERVICE_MAP = useServiceMap();

const position = inject('position');

const { data, loading, error, run } = useRequest(getVouchers, { immde: true });

const nearestRef = ref();

const voucherVisible = ref(false);
const serviceVisible = ref(false);

const selected = ref({});

const scheduled = computed(
  () => store.state?.prefetch?.storeInfo?.scheduled || {},
);
/**
 * 1. 过滤掉只支持fullDineIn的优惠券列表（没有桌号），并计算出可用的数字
 * 2. 对每张优惠券支持的服务方式进行过滤，如果结果为空点不可点击
 */
const voucherList = computed(() => {
  const vs = data.value?.data || [];
  const list = vs.filter((it) => {
    const hasTable = !!getTable();
    if (it.serviceTypeAllowedList.constructor === Array) {
      // dineIn 模式过滤 FULL_DINE_IN的服务类型
      if (app.storeInfo.dineIn) {
        it.serviceTypeAllowedList = it.serviceTypeAllowedList.filter(
          (serviceKey) => serviceKey !== 'FULL_DINE_IN',
        );
      }
      // fullDineIn 模式过滤 DINE_IN的服务类型
      if (app.storeInfo.fullDineIn) {
        it.serviceTypeAllowedList = it.serviceTypeAllowedList.filter(
          (serviceKey) => serviceKey !== 'DINE_IN',
        );
      }
      let services = it.serviceTypeAllowedList.join(',');
      const onlyAllowFull = services === 'FULL_DINE_IN';
      const supportFull = services.indexOf('FULL_DINE_IN') >= 0;
      if (onlyAllowFull && !hasTable) return false;
      // 支持full并且没有桌号，需要将FullDineIn服务模式清除
      if (supportFull && !hasTable) {
        services = services?.replace(/,?FULL_DINE_IN/, '');
      }
      it.serviceTypeAllowedList = services;
    }
    return true;
  });
  return list;
});
const serviceMap = computed(() =>
  voucherList.value.reduce((pre, it) => {
    let list = it.serviceTypeAllowedList?.split(',')?.filter(Boolean) || [];
    const supPickup = list.includes('PICK_UP');
    const supDelivery = list.includes('DELIVERY');
    const { scheduledEnable, scheduledDelivery, scheduledPickUp } =
      scheduled.value || {};
    // 优惠券支持预订单，加模式加入到列表里
    if ((scheduledEnable && scheduledDelivery, supDelivery)) {
      list.push('SCHEDULED_DELIVERY');
    }
    if (scheduledEnable && scheduledPickUp && supPickup) {
      list.push('SCHEDULED_PICK_UP');
    }
    // 过滤店铺支持的服务方式和优惠券支持的服务方式的交集
    list = list.filter((item) => support(item));
    const oList = list.map((item) => ({
      ...SERVICE_MAP.value[item],
      id: item,
    }));
    if (oList.length === 0) return pre;
    return { ...pre, [it.voucherCode]: oList };
  }, {}),
);
const showModule = computed(() => Object.keys(serviceMap.value).length);
const serviceList = computed(
  () => serviceMap.value[selected.value.voucherCode],
);

function onChooseService(it) {
  // if (it?.indexOf('DELIVERY') >= 0) {
  //   nearestRef.value.handleShowNearest('DELIVERY');
  // } else {
  push(it);
  store.commit('Menu/updateAccessStatus', it.replace('SCHEDULED_', ''));
  router.push({ name: 'products-list', query: { table: getTable() } });
  // }
}

function hasDisabled(id) {
  if (!serviceMap.value[id]) return true;
  return serviceMap.value[id]?.length === 0;
}

watchEffect(() => {
  if (voucherVisible.value) run();
});
</script>
<template>
  <div class="hpromo">
    <div
      v-if="showModule || (!app.storeOpened && voucherList.length)"
      class="hpromo-btn"
      @click="voucherVisible = !voucherVisible"
    >
      <span class="hpromo-btn-icon" />
      <div bold>{{ $t('home.voucherTip') }}</div>
      <div class="hpromo-btn-count">
        {{ voucherList.length }} {{ $t('home.vouchers') }}
      </div>
    </div>
    <!--VoucherList-->
    <q-dialog v-model="voucherVisible" maximized>
      <div class="vlist pc-width-pull-full">
        <header class="vlist-head">
          <i class="iconfont dm-arrow-left" @click="voucherVisible = false" />
          <span bold>{{ $t('home.voucherTitle') }}</span>
        </header>
        <main class="vlist-main">
          <VoucherItem
            v-for="it in voucherList"
            :key="it.voucherCode"
            :vo="it"
            :disable="hasDisabled(it.voucherCode)"
            @onClick="(serviceVisible = true), (selected = it)"
          />
        </main>
      </div>
    </q-dialog>
    <!--ServiceType-->
    <q-dialog v-model="serviceVisible" position="bottom">
      <div class="slist">
        <div bold class="slist-head">
          <span>{{ $t('home.serviceTitle') }}</span>
          <i class="iconfont dm-close" @click="serviceVisible = false" />
        </div>
        <div class="slist-main">
          <div
            v-for="(it, index) of serviceList"
            :key="index"
            class="slist-main-item"
            @click="onChooseService(it.id)"
          >
            <img width="32" height="32" :src="it.icon" />
            <span bold>{{ it.label }}</span>
            <i class="iconfont dm-right" />
          </div>
        </div>
      </div>
    </q-dialog>
    <!--Nearest-->
    <Nearest ref="nearestRef" :hide-text="true" :position="position" />
  </div>
</template>
<style lang="scss" scoped>
.hpromo {
  margin: 12px 24px 0;
  &-btn {
    display: flex;
    align-items: center;
    border-radius: $border-radius-3;
    background: #fff;
    padding: 12px 16px;
    font-size: $font-size-1;
    margin-bottom: 4px;
    &-icon {
      margin-right: 8px;
      width: 20px;
      height: 20px;
      background-image: url(https://static.bakmigm.co.id/menu/HomePromo221130.svg);
      background-size: cover;
    }
    &-count {
      margin-left: auto;
      padding: 1px 6px;
      color: #fff;
      border-radius: $border-radius-in;
      background: $primary;
    }
  }
}
.vlist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: $grayBg-2;
  display: flex;
  flex-direction: column;
  &-head {
    font-size: $font-size-6;
    height: 64px;
    line-height: 64px;
    padding: 0 22px;
    background: #fff;
    .iconfont {
      font-size: inherit;
      margin-right: 20px;
    }
  }
  &-main {
    flex: 1;
    overflow: auto;
    padding: 16px;
  }
}
.slist {
  background: #fff;
  display: flex;
  flex-direction: column;
  &-head {
    display: flex;
    height: 48px;
    line-height: 48px;
    padding: 0 16px;
    justify-content: space-between;
  }
  &-main {
    &-item {
      display: flex;
      align-items: center;
      padding: 16px;
      span {
        margin-left: 8px;
        margin-right: auto;
      }
      .iconfont {
        color: $disabledFont;
      }
    }
  }
}
</style>
